import Card from '../common/Card';
import { InsightSkeleton } from './Skeletons';

// Shows at most 3 action items with a scrollable overflow.
// CSS: .insight-scroll-list sets max-height + overflow in styles.css
const TopActionsCard = ({ title, actions, total, loading, entityName = 'items', onAction }) => (
  <Card className="first insight-card" title={title}>
    {loading ? (
      <InsightSkeleton />
    ) : !actions?.length ? (
      <div className="empty-insight-placeholder">
        <span className="empty-insight-ico">✓</span>
        <div className="empty-insight-title">All {entityName} look good</div>
        <div className="empty-insight-desc">No savings opportunities found for this view.</div>
      </div>
    ) : (
      <>
        {total > 0 && (
          <span className="insight-total-label">
            ${total.toFixed(2)} / mo potential saving
          </span>
        )}
        <div className="insight-scroll-list">
          {actions.map((item) => (
            <div key={item.id} className="insight-item">
              <div className="insight-item-top">
                <div className="insight-item-title">{item.title}</div>
                <div className="insight-item-amt">{item.amount}</div>
              </div>
              <div className="insight-item-desc">{item.desc}</div>
              <button className="mini-btn ai-assist" onClick={() => onAction && onAction(item)}>Assist with AI</button>
            </div>
          ))}
        </div>
      </>
    )}
  </Card>
);

export default TopActionsCard;
